import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
/**
 * 子导航 配置示例
 */
// {
//   path: '/software',
//     name: 'software',
//   component: resolve => require(['@/view/Software'], resolve),
//   meta: {
//   title: '软件产品'
// },
//   children: [
//     {
//       path: '/software',
//       redirect: '/software/smartTown'
//     },
//     {
//       path: '/software/smartTown',
//       name: 'software',
//       component: resolve => require(['@/view/Software_smartTown'], resolve),
//       meta: {
//         title: '软件产品丨智能小镇管理系统'
//       }
//     },
//     {
//       path: '/software/bigData',
//       name: 'software',
//       component: resolve => require(['@/view/Software_bigData'], resolve),
//       meta: {
//         title: '软件产品丨大数据管理系统'
//       }
//     }
//   ]
// },

export default new Router({
  /**
   * 切换页面置顶
   * @param to
   * @param from
   * @param savedPosition
   * @returns {Position|{x: number, y: number}}
   */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      document.title =`四川明槊科技有限公司_${to.meta.title}-智慧停车管理系统${to.meta.title}-闲狐智慧停车系统`
      return { x: 0, y: 0 }
    }
  },
  mode:'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/Home'], resolve),
          meta: {
            title: '四川明槊科技有限公司官网',
            keepAlive:true,
          }
        },{
          path: '/homePage',
          name: 'homePage',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },{
          path: '/companyintroduction',
          name: 'CompanyIntroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '走进明槊'
          }
        },{
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '产品中心'
          }
        },{
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '解决方案'
          }
        }, {
          path: '/applicationCases',
          name: 'applicationCases',
          component: resolve => require(['@/view/ApplicationCases'], resolve),
          meta: {
            title: '应用案例'
          }
        },  {
          path: '/cooperation',
          name: 'cooperation',
          component: resolve => require(['@/view/Cooperation'], resolve),
          meta: {
            title: '应用案例'
          }
        },{
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻资讯'
          }
        },{
          path: 'newsdetail',
          name: 'newsdetail',
          component: resolve => require(['@/view/Newsdetail'], resolve),
          meta: {
            title: '明槊新闻'
          }
        },{
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '招聘信息'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js